import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from './DatePicker';

/**
 * SelectKaishibiNew
 */
class SelectKaishibiNew extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenFrom = this.handleOpenFrom.bind(this);
    this.handleOpenTo = this.handleOpenTo.bind(this);
  }

  componentDidMount() {
    const nohinFrom = document.getElementById('select_nohin_term_from');
    if (nohinFrom) {
      nohinFrom.addEventListener('click', this.handleOpenFrom);
    }
    const nohinTo = document.getElementById('select_nohin_term_to');
    if (nohinTo) {
      nohinTo.addEventListener('click', this.handleOpenTo);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.data.isOpenCalendar) {
      // 期間が変更された場合は更新する
      if (this.props.data.displayDate !== nextProps.displayDate) {
        return true;
      }
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    const nohinFrom = document.getElementById('select_nohin_term_from');
    if (nohinFrom) {
      nohinFrom.removeEventListener('click', this.handleOpen);
    }
    const nohinTo = document.getElementById('select_nohin_term_to');
    if (nohinTo) {
      nohinTo.removeEventListener('click', this.handleOpen);
    }
  }

  handleOpenFrom() {
    let currentDate = this.props.data.nohinkaishibiFrom;
    if (currentDate != null && currentDate != undefined && currentDate != '') {
      currentDate = new Date(this.props.data.nohinkaishibiFrom);
    } else {
      // 未選択の場合は納品開始日データから設定する
      currentDate = new Date(this.props.data.nohinTermData.data[0].model.nohinkaishibi);
    }

    const nohinTo = this.props.data.nohinkaishibiTo;
    if (nohinTo) {
      const nohinToDate = new Date(nohinTo);
      if (currentDate > nohinToDate) {
        currentDate = nohinToDate;
      }
    }
    const viewMode = 'day';
    const isNohinCalendar = true;
    const isFromDatePicker = true;
    this.props.comactions.openDatePicker(currentDate, isNohinCalendar, viewMode, isFromDatePicker);
  }

  handleOpenTo() {
    let currentDate = this.props.data.nohinkaishibiTo;
    if (currentDate != null && currentDate != undefined && currentDate != '') {
      currentDate = new Date(this.props.data.nohinkaishibiTo);
    } else {
      // 未選択の場合は納品開始日データから設定する
      currentDate = new Date(this.props.data.nohinTermData.data[0].model.nohinkaishibi);
    }

    const viewMode = 'day';
    const isNohinCalendar = true;
    const isFromDatePicker = false;
    this.props.comactions.openDatePicker(currentDate, isNohinCalendar, viewMode, isFromDatePicker);
  }

  formatDisplayDate(date) {
    if (date === undefined || date === null) {
      return '';
    }
    return date ? date.replace(/-/g, ' / ') : '';
  }

  render() {
    const nohinFrom = this.formatDisplayDate(this.props.data.nohinkaishibiFrom);
    const nohinTo = this.formatDisplayDate(this.props.data.nohinkaishibiTo);
    let displayTextFrom = nohinFrom || '指定なし';
    let displayTextTo = nohinTo || '指定なし';

    return (
      <div id="nohin_jiki" className="filter_item">
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
          <p>納品時期で絞る</p>
        </div>
        <div className="select_nohin_terms">
          <div id="select_nohin_term_from" className="select_kikan_term nohin_from">
            <div id="sort_date" className="controlForm__Kikan--state_enable" data-title="calender01">
              <p className="sel_term">{displayTextFrom}</p>
              <a className="btn sort_reload" href="#">
                <span className="date_range" />
              </a>
            </div>
          </div>
          <div className="select_nohin_between">
            <span className="select_nohin_between_mark">～</span>
          </div>
          <div id="select_nohin_term_to" className="select_kikan_term nohin_to">
            <div id="sort_date" className="controlForm__Kikan--state_enable" data-title="calender01">
              <p className="sel_term">{displayTextTo}</p>
              <a className="btn sort_reload" href="#">
                <span className="date_range" />
              </a>
            </div>
          </div>
        </div>
        {this.props.data.isOpenCalendar && this.props.data.isNohinCalendar && (
          <DatePicker
            comactions={this.props.comactions}
            data={this.props.data}
          />
        )}
      </div>
    );
  }
}

SelectKaishibiNew.propTypes = {
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectKaishibiNew;
